import { createCFF, ContextFormField } from '@components/context-form-field';
import { ScrollSectionTitle } from '@components/scroll-section-title';
import { ContentType } from '@lib/content';
import { Divider, Grid } from '@material-ui/core';
import { amber } from '@material-ui/core/colors';
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded';
import { useFormContext } from 'react-hook-form';
import { MovieIcon } from '@icon/movie-icon';
import { TvSeriesIcon } from '@icon/tv-series-icon';

export const ContentInformationSection = () => {
  const { control, watch } = useFormContext();
  const isSeries = watch('content_type', ContentType.SERIES) === ContentType.SERIES;
  // const isMovie = watch('content_type', ContentType.MOVIE) === ContentType.MOVIE;
  const contentTypeWatch = watch('content_type')
  let label = "TV Show"
  let desc = "Attributes of the TV series"
  let isMovie = false
    if(contentTypeWatch == ContentType.SERIES){
      label = "TV Show"
      desc = "Attributes of the TV series"
      isMovie = false
    }
    else if(contentTypeWatch == ContentType.MOVIE){
      label = "MOVIE"
      desc = "Attributes of the Movie"
      isMovie = true
    }
    else if(contentTypeWatch == ContentType.BOOK){
      label = "BOOK"
      desc = "Attributes of the Book"
      isMovie = false
    }
    else if(contentTypeWatch == ContentType.PODCAST){
      label = "PODCAST"
      desc = "Attributes of the Podcast"
      isMovie = false
    }
    else if(contentTypeWatch == ContentType.GAME){
      label = "GAME"
      desc = "Attributes of the Game"
      isMovie = false
    }
    else if(contentTypeWatch == ContentType.FORMAT){
      label = "FORMAT"
      desc = "Attributes of the Format"
      isMovie = false
    }
    else if(contentTypeWatch == ContentType.STORY){
      label = "STORY/SCRIPT"
      desc = "Attributes of the Story/Script"
      isMovie = false
    }
  return (
    <>
      <ScrollSectionTitle
        id="content-info"
        subTitle={desc}
        icon={isSeries ? <TvSeriesIcon fontSize="large" /> : <MovieIcon fontSize="large" />}>
        {label} Details
      </ScrollSectionTitle>
      <Divider />
      <br />
      <Grid container spacing={2}>
        {(!isMovie ? seriesAttributes : movieAttributes).map((attr, idx) => (
          <Grid key={attr.index} item xs={4}>
            {typeof attr === 'function' ? (attr as any)(control) : <ContextFormField {...attr} />}
          </Grid>
        ))}
        {/* <Grid item xs>
          <ReleaseDateField control={control} name="release_date" />
          <br />
          <br />
          <LanguageField control={control} name="genres" />
        </Grid> */}
      </Grid>
    </>
  );
};

const seriesAttributes = [
  createCFF({
    index: 0,
    name: 'runtime',
    helperText: 'Avg Episode runtime (minutes)',
    label: 'Episode Runtime',
  }),

  createCFF({
    index: 1,
    type: 'number',
    name: 'number_of_seasons',
    helperText: 'Total number of seasons',
    label: '#Seasons',
  }),

  createCFF({
    index: 2,
    type: 'number',
    name: 'number_of_episodes',
    helperText: 'Total number of episodes in the series.',
    label: '#Episodes',
  }),
];

const movieAttributes = [
  createCFF({
    index: 3,
    name: 'runtime',
    helperText: 'Running time of the movie (minutes)',
    label: 'Runtime',
  }),
  createCFF({
    index: 4,
    type: 'number',
    name: 'revenue',
    helperText: 'Total revenue of the project. (Optional).',
    label: 'Revenue',
    icon: '$',
  }),
];
